export default "__VITE_ASSET__b2de61e2__"